import dialogPolyfill from 'dialog-polyfill';
var DialogHandler = /** @class */ (function () {
    function DialogHandler(props) {
        var _a, _b;
        this.wrapper = undefined;
        this.closeButton = undefined;
        this.triggers = undefined;
        this.init = this.init.bind(this);
        this.open = this.open.bind(this);
        this.close = this.close.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.wrapper = props.wrapper;
        this.closeButton = props.closeButton;
        this.triggers = (_a = props.triggers) !== null && _a !== void 0 ? _a : [];
        this.shouldEnableTriggers = (_b = props.shouldEnableTriggers) !== null && _b !== void 0 ? _b : true;
        this.closeAction = props.closeAction;
        this.init();
    }
    DialogHandler.prototype.init = function () {
        var _this = this;
        dialogPolyfill.registerDialog(this.wrapper);
        this.wrapper.addEventListener('close', function () { return _this.handleClose(); });
        this.wrapper.addEventListener('cancel', function (e) {
            if (_this.wrapper.classList.contains("dialog")) {
                e.preventDefault();
                _this.closeAnimation();
            }
            else {
                _this.close();
            }
        });
        if (this.triggers.length) {
            var openHandler_1 = function (event) {
                if (_this.shouldEnableTriggers) {
                    event.preventDefault();
                    _this.open();
                    _this.dialogOpenCloseEvent();
                }
            };
            this.triggers.forEach(function (trigger) {
                if (trigger) {
                    trigger.addEventListener('click', openHandler_1);
                }
            });
        }
        var closeHandler = function (event) {
            event.preventDefault();
            if (_this.wrapper.classList.contains("dialog")) {
                _this.closeAnimation();
            }
            else {
                _this.close();
            }
        };
        if (this.closeButton) {
            this.closeButton.addEventListener('click', closeHandler);
        }
        window.addEventListener('load', function () {
            if (_this.wrapper.classList.contains("js-open-on-load")) {
                _this.open();
                _this.wrapper.querySelectorAll('.js-success-close').forEach(function (successCloseBtn) {
                    if (successCloseBtn) {
                        successCloseBtn.addEventListener('click', closeHandler);
                    }
                });
            }
        });
    };
    DialogHandler.prototype.dialogOpenCloseEvent = function () {
        var emitDialogEvent = new CustomEvent("toggle-dialog" /* dialog.toggle */, { bubbles: true });
        document.body.dispatchEvent(emitDialogEvent);
    };
    DialogHandler.prototype.lockBody = function () {
        document.body.style.overflow = "hidden";
    };
    DialogHandler.prototype.unlockBody = function () {
        document.body.style.overflow = "";
    };
    DialogHandler.prototype.handleClose = function () {
        var _a;
        this.unlockBody();
        (_a = this.closeAction) === null || _a === void 0 ? void 0 : _a.call(this);
    };
    DialogHandler.prototype.closeAnimation = function () {
        var _this = this;
        this.wrapper.classList.add("hide");
        var close;
        this.wrapper.addEventListener("animationend", close = function () {
            _this.wrapper.classList.remove('hide');
            _this.close();
            _this.dialogOpenCloseEvent();
            _this.wrapper.removeEventListener("animationend", close);
        });
    };
    DialogHandler.prototype.enableTriggers = function (shouldEnableTriggers) {
        this.shouldEnableTriggers = shouldEnableTriggers;
    };
    DialogHandler.prototype.open = function () {
        this.wrapper.showModal();
        this.dialogOpenCloseEvent();
        this.lockBody();
    };
    DialogHandler.prototype.close = function () {
        this.wrapper.close();
        this.dialogOpenCloseEvent();
        this.unlockBody();
    };
    return DialogHandler;
}());
export { DialogHandler };
export default DialogHandler;
